import _ from 'lodash'
import { ENTRIES_LOADED } from '../constants';

const initialState = {byContentfulId: {}, all:[]};

export default function update(state = initialState, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.tour) {
                const result = initialState;
                Object.keys(action.entries.tour).map(key => {
                    result.byContentfulId[key] = action.entries.tour[key];
                    result.all.push(action.entries.tour[key]);
                })
                return result
            }
            break;
    }
    return state;
}
